import React from "react";
import Select from "../Inputs/Select";

export function SelectInput({
  label,
  options,
  setOption,
  option,
  prefix,
  validate,
  disabled = false,
}) {
  return (
    <Select
      options={options}
      defaultValue={!option && `Select (${options?.length})`}
      handleChange={(value) => {
        setOption(value);
      }}
      value={option}
      prefix={prefix}
      label={label}
      id={label}
      validate={validate}
      disabled={disabled}
    />
  );
}
